// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_22jt_","social-link-item":"_39hw2"};